exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".company-section {\n  width: 100%;\n  height: auto;\n  position: relative;\n  z-index: 1; }\n\n.deserts-image {\n  width: 100%;\n  height: auto; }\n\n.section-image {\n  margin: auto;\n  text-align: center;\n  height: 455px;\n  background-size: cover; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/corpo-leve-www/www/src/app/company/company.component.scss
// module id = ../../../../../src/app/company/company.component.scss
// module chunks = main